import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  Hairline,
  TabButton,
  TabSet,
  HeaderOne,
  BodyCopy,
} from 'secondstep-components'
import { DefaultSiteSelectorWrapper } from 'components/SiteSelector'

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
`

export const HeaderBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% + 60px);
  background: ${themeGet('colors.backgrounds.banners.primary', 'colors.white')};
  z-index: 1;
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};
  box-sizing: border-box;
  padding: ${({ isPreview }) => (isPreview ? '3.625rem' : '0')} 1.25rem;
  z-index: 1;

  .pathways_dropdown {
    display: none;
  }

  .text-wrapper {
    ${HeaderOne} {
      margin-bottom: 1.25rem;
      color: ${themeGet('colors.headers.primaryHeader')};
      font-family: ${themeGet('fonts.primary')};
      font-size: 42px;
      font-weight: 800;
      letter-spacing: 1.11px;
      line-height: 46px;
    }
    ${BodyCopy} {
      padding-bottom: 1.75rem;
      color: ${themeGet('colors.darkGray')};
      font-family: ${themeGet('fontFamily')};
      font-size: 1rem;
    }
  }
  .pathways_dropdown button {
    background-color: none;
  }

  ${themeGet('breakpoints.tablet')} {
    .content-overview-wrapper {
      align-items: start;
    }
  }
  ${themeGet('breakpoints.mobileLarge')} {
    padding: ${({ isPreview }) => (isPreview ? '3.625rem' : '0')} 1rem 0;
    text-align: center;
    .pathways_dropdown {
      display: inline;
    }
  }
`

export const StyledHairline = styled(Hairline)`
  z-index: 1;
  background-color: ${themeGet('colors.gray500')};
  height: 1px;
`

export const StyledTabButton = styled(TabButton).attrs(({ isActive }) => ({
  backgroundColor: isActive
    ? themeGet('colors.heading.level.2')
    : 'transparent',
  fontFamily: isActive
    ? themeGet('fontFamilySemibold')
    : themeGet('fontFamily'),
}))`
  margin-top: 1.75rem;
  margin-right: 1.75rem;
  padding-bottom: 10px;
  [class*='StyledBox'] {
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ isActive }) =>
      isActive
        ? themeGet('colors.themePrimary')
        : themeGet('colors.headers.primaryHeader')};

    &:hover {
      color: ${themeGet('colors.themePrimary')};
    }
  }

  [class*='Underline'] {
    display: ${({ isActive }) => (isActive ? 'in-line' : 'none')};
    background-color: ${themeGet('colors.themePrimary')};
    position: relative;
    top: 4px;
  }
`

export const StyledTabSet = styled(TabSet)`
  flex-wrap: wrap;
  height: auto;
  margin-bottom: 1.25rem;
  ${themeGet('breakpoints.mobileLarge')} {
    display: none;
  }
  z-index: 1;

  [class*='StyledTabsHeader'] {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
`

export const BannerSpacer = styled.div`
  margin-top: 7rem;
`

export const SiteSelectorWrapper = styled(DefaultSiteSelectorWrapper)`
  padding-right: 0;
  background: ${themeGet('colors.backgrounds.banners.primary', 'colors.white')};

  ${themeGet('breakpoints.mobileLarge')} {
    margin-bottom: 1.25rem;
  }
`
